export default __webpack_public_path__ + "static/media/TA.453c0c9a.mp3";